import { render, staticRenderFns } from "./Announce.vue?vue&type=template&id=2f82060d&scoped=true&"
var script = {}
import style0 from "./Announce.vue?vue&type=style&index=0&id=2f82060d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82060d",
  null
  
)

export default component.exports